<template>
  <div class="row g-4 mt-n4">
    <div class="col-md-12 col-lg-12 col-sm-12">
      <h6 class="text-secondary">Search by title</h6>
      <div class="input-group" style="height: 90%;">
        <input id="filter_text" 
          v-model="filter_text" 
          data-test="filter_text" 
          :placeholder="$t('network.search')" 
          type="text" 
          class="form-control shadow-sm"
          :class="filter_text.length || isInputFocused ? 'border-2' : 'border-0'" 
          :style="{ height: '65%', borderColor: (filter_text.length || isInputFocused) ? '#3AD2EA' : '', borderRight: '1px #dfdfeb !important' }"
          autofocus 
          @focus="isInputFocused = true" 
          @blur="isInputFocused = false" />
        <span id="basic-addon2" 
          class="input-group-text shadow-sm" 
          :class="filter_text.length || isInputFocused ? 'border-2' : 'border-0'"
          :style="{ height: '65%', borderColor: (filter_text.length || isInputFocused) ? '#3AD2EA' : '', borderLeft: '1px #dfdfeb !important' }">
          <i class="fa fa-search"></i>
        </span>
      </div>
    </div>

    <div class="col-md-12 col-lg-12 col-sm-12">
      <h6 class="text-secondary">{{ $t('network.filterByMediaPresenter') }}</h6>
      <PresenterSearch v-model="presenter" :networkSlug="network ? network.slug : null" />
    </div>

    <div class="col-md-12 col-lg-12 col-sm-12">
      <h6 class="text-secondary">Filter by language</h6>
      <v-select
        v-model="selectedLanguages"
        :options="allLanguages"
        label="language"
        multiple
        placeholder="Select languages"
      ></v-select>
    </div>

    <div v-if="!network" class="col-md-12 col-lg-12 col-sm-12 mb-n1">
      <h6 class="text-secondary">{{ $t('filter-by-network') }}</h6>
      <div class="row">
        <div v-for="(filter_by_network_option, filter_by_network_index) in filter_by_network_options" :key="filter_by_network_index" class="col-12 p-0">
          <div class="form-check">
            <label class="form-check-label fs-6" :for="'sort_by_network_' + filter_by_network_index">
              <input
                :id="'sort_by_network_' + filter_by_network_index"
                v-model="chosen_network"
                :data-test="'sort_by_network_' + filter_by_network_index"
                name="filterByNetwork[]"
                type="radio"
                :value="filter_by_network_option.value"
                class="form-check-input"
                @change="updateChosenNetworkIndex(filter_by_network_index)"
              />
              {{ $t(filter_by_network_option.text) }}
            </label>
          </div>
        </div>
        <div v-if="selectedNetworkIndex != '0'" class="px-0 py-2">
          <div class="col-12">
            <v-select
              v-model="specific_network"
              :options="allNetworks"
              label="name"
              class="border-0"
              placeholder="Select network"
              :clearable=false
              @change="updateChosenNetworkIndex(filter_by_network_index)"
            >
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.name }}
              </div>
            </template>
            </v-select>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-lg-12 col-sm-12">
      <TagSearch v-model="tagSlug" :networkSlug="network ? network.slug : null" :inCourseFeed=true />
    </div>

    <div class="text-center">
      <button id="reset_filter" 
        data-test="reset_filter" 
        class="btn btn-secondary" 
        style="width: 95%;" 
        @click="cleanFilter()">
        <i class="fas fa-undo"></i>
        {{ $t('network.resetFilter') }}
      </button>
    </div>
  </div>
</template>
<script>
import PresenterSearch from '@/components/commons/Presenters/PresenterCourseSearch.vue';
import TagSearch from '@/components/commons/Tags/TagSearch.vue';
import { mapGetters } from 'vuex';
import vSelect from 'vue-select';
import _ from 'lodash';
import 'vue-select/dist/vue-select.css';

export default {
  components: {
    PresenterSearch,
    TagSearch,
    vSelect,
  },
  props: {
    network: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      filter_by_network_options: [
        { text: 'network.sortOptions.allNetworks', value: '0' },
        { text: 'network.sortOptions.selectedNetworks', value: '' },
      ],
      isInputFocused: false,
      selectedNetworkIndex: '0',
      specific_network: '',
      specific_language: '',
    };
  },
  computed: {
    filter_text: {
      get: function () {
        return this.$store.state.course_feed.filter_text;
      },
      set: function (v) {
        this.$store.commit('course_feed/filter_text', v);
      },
    },
    tagSlug: {
      get() {
        return this.$store.state.course_feed.tagSlug;
      },
      set(v) {
        this.$store.commit('course_feed/tagSlug', v);
      },
    },
    presenter: {
      get() {
        return this.$store.state.course_feed.presenter;
      },
      set(v) {
        this.$store.commit('course_feed/presenter', v);
      },
    },
    selectedLanguages: {
      get() {
        return this.$store.state.course_feed.selectedLanguages;
      },
      set(v) {
        this.$store.commit('course_feed/selectedLanguages', v);
      },
    },
    chosen_network: {
      get() {
        return this.$store.state.course_feed.chosen_network;
      },
      set(v) {
        this.$store.commit('course_feed/chosen_network', v);
      },
    },
    ...mapGetters({
      isAnyFilterSelected: 'course_feed/isAnyFilterSelected',
      allNetworks: 'network/getAllNetworks',
      allLanguages: 'content_language/allLanguagesWithUserPreferenceIncluded',
    }),
  },
  watch: {
    specific_network: {
      handler: function (val) {
        if (val) {
          if (window.umami && typeof window.umami.track === 'function') {
            window.umami.track(`course-feed-filter-network-${val.id}`);
          }
          this.$store.commit('course_feed/chosen_network', val);
        }
      },
      deep: true,
    },
    specific_language: {
      handler: function (val) {
        if (val) {
          this.$store.commit('course_feed/selectedLanguages', [val]);
        }
      },
      deep: true,
    },
    filter_text: {
      handler: function(newValue, oldValue) {
        if (newValue !== oldValue && newValue.trim() !== '') {
          // using debounce to avoid triggering too many events
          this.debouncedTrackFilterText(newValue);
        }
      }
    },
  },
  mounted() {
    this.$store.commit('course_feed/RESET_STATE');
    this.$store.dispatch('content_language/loadLanguages');
    this.$store.dispatch('content_language/loadMyPreferredLanguages');
  },
  methods: {
    cleanFilter() {
      this.$store.commit('course_feed/RESET_STATE');
      this.$store.dispatch('course_feed/loadCourses');
      this.selectedNetworkIndex = 0;
      this.specific_network = '';
      this.$bus.emit('reset-tag-filter');
    },
    updateChosenNetworkIndex(index) {
      this.selectedNetworkIndex = index;
    },
    debouncedTrackFilterText: _.debounce(function(text) {
      this.trackFilterText(text);
    }, 500),
    trackFilterText(text) {
      if (window.umami && typeof window.umami.track === 'function') {
        window.umami.track(`course-feed-filter-text-${text}`);
      }
    },
  },
};
</script>
<style scoped>
.vue-daterange-picker {
  min-width: 100%;
}
</style>